import * as React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { useAppSelector, useAppDispatch, DefaultRoutes, PathInfo, SearchNode, DriveEntryType, buildNavigationLink, DriveUIActionTypes, isSameIdentifier } from "src/common";
import { driveActions } from "src/store";
import { RootState } from "src/store/configureStore";
import _ from "lodash";

type AllProps = {
  search_node: SearchNode;
  path_info?: PathInfo[];
  root_item?: string;
  handleAction: ActionHandlerFunction;
}

function BreadcrumbsComponent(props: AllProps) {
  const { path_info, search_node, root_item, handleAction } = props;
  const current_directory_id = useAppSelector((state: RootState) => state.drive.current_directory?.id);
  const dispatch = useAppDispatch();

  // Description: Build File type last node url to MyPreVeil link
  function getEntityURLbyType(node: PathInfo) {
    return (search_node.type === DriveEntryType.FILE && search_node.id === node.id && !!search_node.parent_id) ?
      buildNavigationLink(search_node.collection_id, search_node.parent_id, search_node.type, search_node.id) : (node.url || DefaultRoutes.drive_root);
  }

  return <Breadcrumb className="drive-breadcrumbs" as="div">
    {
      !!root_item &&
      <>
        <Breadcrumb.Item
          as="span"
          className="bc-title"
          onClick={(e) => { e.stopPropagation(); }}
          linkAs={Link}
          linkProps={{
            to: DefaultRoutes.drive_root
          }}>{root_item}</Breadcrumb.Item>
      </>
    }
    {
      !!path_info &&
      _.map(path_info, (node: PathInfo, index: number) => {
        const is_root = index === 0 && !root_item;
        return <Breadcrumb.Item key={`path_${index}`}
          as="span"
          onClick={(e) => {
            e.stopPropagation();
            // NOTE: If file exists in the current directory, force a reload of the current dir, otherwise file will not load
            isSameIdentifier(search_node.parent_id, current_directory_id) &&
              dispatch(driveActions.setReloadDriveList(true));
            handleAction({ actionType: DriveUIActionTypes.Reset });
          }}
          className={is_root ? "bc-title" : ""}
          linkAs={Link}
          linkProps={{ to: (getEntityURLbyType(node)) }}>
          {node.path}</Breadcrumb.Item>;
      })
    }

  </Breadcrumb>;
}

export default React.memo(BreadcrumbsComponent);
